import axios from 'axios';
import { isCart, isCheckout, isReceipt, isProfileSuccess } from './locationHelpers';

const getUserProfile = () => axios.get('/index.cfm?method=memberEditAccount.editProfile', {
  responseType: 'text',
})
  .then((response) => {
    const html = new DOMParser().parseFromString(response.data, 'text/html');
    const memberForm = html.querySelector('#v65-memberFormWrapper form');
    if (!memberForm) { // Not logged in
      return false;
    }

    const inputs = memberForm.getElementsByTagName('input');
    const selects = memberForm.getElementsByTagName('select');

    const memberProfile = {
      db: getBirthdate(selects),
      em: getFieldValue(inputs.Email),
      fn: getFieldValue(inputs.FirstName),
      ln: getFieldValue(inputs.LastName),
      ct: getFieldValue(inputs.City),
      zp: getFieldValue(inputs.ZipCode),
      sc: getFieldValue(selects.StateCode),
    };

    Object.keys(memberProfile).forEach(key => (memberProfile[key] == null) && delete memberProfile[key]);

    return memberProfile;
  });

const setUserProfile = () => {
  const userProfile = document.getElementsByClassName('v65-editProfile');
  const storedProfile = localStorage.getItem('vtUserProfile');

  if (isProfileSuccess || (!storedProfile && userProfile.length)) {
    return getUserProfile()
      .then((profile) => {
        if (profile) {
          localStorage.setItem('vtUserProfile', JSON.stringify(profile));
        }
      });
  }

  if (isCart || isCheckout || isReceipt) {
    return storedProfile;
  }

  if (!userProfile.length) {
    localStorage.removeItem('vtUserProfile');
    return {};
  }

  return storedProfile;
};

const getFieldValue = field => field && field.value.toLowerCase();

const getBirthdate = (fields) => {
  const year = getFieldValue(fields.BirthYear);
  let month = getFieldValue(fields.BirthMonth);
  let day = getFieldValue(fields.BirthDay);

  if (!year || !month || !day) {
    return null;
  }

  if (month < 10) {
    month = `0${month}`;
  }

  if (day < 10) {
    day = `0${month}`;
  }

  return parseInt(`${year}${month}${day}`, 10);
};

export { setUserProfile }; // eslint-disable-line import/prefer-default-export
